import { api } from "@/lib/api";
import { logger } from "@/lib/logger";

// Convert VAPID base64url public key to Uint8Array required by pushManager.subscribe
function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) arr[i] = raw.charCodeAt(i);
  return arr;
}

export function isPushSupported() {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

export function pushPermission() {
  if (typeof Notification === "undefined") return "unsupported";
  return Notification.permission; // "default" | "granted" | "denied"
}

/** Returns the current PushSubscription (or null). */
export async function getCurrentSubscription() {
  if (!isPushSupported()) return null;
  const reg = await navigator.serviceWorker.ready;
  return reg.pushManager.getSubscription();
}

/** Subscribe + persist on backend. Returns the subscription. */
export async function enablePush() {
  if (!isPushSupported()) throw new Error("PushNotSupported");
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("PermissionDenied");
  const { data } = await api.get("/push/vapid-public-key");
  if (!data?.public_key) throw new Error("MissingVapidKey");

  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.public_key),
    });
  }
  const json = sub.toJSON();
  await api.post("/push/subscribe", {
    endpoint: json.endpoint,
    keys: json.keys,
  });
  return sub;
}

/** Unsubscribe locally and on server. */
export async function disablePush() {
  const sub = await getCurrentSubscription();
  if (!sub) return;
  const json = sub.toJSON();
  try {
    await api.post("/push/unsubscribe", {
      endpoint: json.endpoint,
      keys: json.keys,
    });
  } catch (e) { logger.warn("push unsubscribe api", e); }
  await sub.unsubscribe();
}

export async function sendTestPush() {
  return api.post("/push/test");
}

export async function checkAlerts() {
  try {
    const r = await api.post("/push/check-alerts");
    return r.data;
  } catch (e) {
    logger.warn("push check-alerts", e);
    return null;
  }
}
